import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';

export default function AuthConfirmPage() {
  const [error, setError] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const confirmAuth = async () => {
      const tokenHash = searchParams.get('token_hash');
      const type = searchParams.get('type');

      if (!tokenHash || !type) {
        setError('Invalid or missing confirmation link.');
        return;
      }

      const { error } = await supabase.auth.verifyOtp({ token_hash: tokenHash, type });

      if (error) {
        setError(error.message || 'Verification failed. The link may have expired.');
        return;
      }

      if (type === 'recovery') {
        navigate('/reset-password', { replace: true });
      } else {
        navigate('/models', { replace: true });
      }
    };

    confirmAuth();
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-100 py-12 px-4">
        <div className="max-w-md w-full text-center space-y-4">
          <img className="mx-auto h-10 w-auto" src="/logo_wordmark.svg" alt="SharpeMetrix" />
          <h2 className="text-xl font-bold text-text-100">Verification failed</h2>
          <p className="text-text-200 text-sm">{error}</p>
          <a
            href="/forgot-password"
            className="inline-block py-2 px-4 text-sm font-medium rounded-md text-text-100 bg-primary-100 hover:bg-primary-200"
          >
            Request a new link
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-100">
      <p className="text-text-200">Verifying your link...</p>
    </div>
  );
}
